import { render } from "./SocialIcon.vue?vue&type=template&id=3b9f15ec&ts=true"
import script from "./SocialIcon.vue?vue&type=script&lang=ts"
export * from "./SocialIcon.vue?vue&type=script&lang=ts"

import "./SocialIcon.vue?vue&type=style&index=0&id=3b9f15ec&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__